import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getInvoiceModalHtml } from './product-page';
export default function productList() {
  if (!document.body.classList.contains('archive')) return;
  addOpenInvoiceModalListeners();
  addListenerToCatFilter();
  addListenerToFilterList();
  addClassToActiveFilterButton();
  showBrandFilter();
}
function showBrandFilter() {
  var brandFilters = [];
  $('.custom-brand').each(function () {
    var newBrand = $(this).text().trim();
    if (!brandFilters.includes(newBrand)) {
      brandFilters.push(newBrand);
    }
  });
  console.log(brandFilters);
  if (brandFilters.length) {
    $('#wl-product-categories__list').after('<div id="wl-product-categories__brand"></div>');
    for (var i = 0; i < brandFilters.length; i++) {
      $('#wl-product-categories__brand').append('<a class="button" href="' + window.location.pathname + '?filter_varumarke=' + brandFilters[i] + '">' + brandFilters[i] + '</a>');
    }
  }
}
function addClassToActiveFilterButton() {
  var url = new URL(window.location);
  var urlPath = url.pathname.split('/');
  var categoryBtns = _toConsumableArray(document.querySelectorAll('#wl-product-categories__list button'));
  var _iterator = _createForOfIteratorHelper(categoryBtns),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var btn = _step.value;
      if (urlPath.includes(btn.dataset.slug)) {
        btn.classList.add('chosen-cat');
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function addListenerToFilterList() {
  var filterList = document.getElementById('wl-product-categories__list');
  var filterSelect = document.getElementById('wl_category_filter');
  if (!filterList || !filterSelect) return;
  filterList.addEventListener('click', function (e) {
    var clickedFilter = e.target;
    var chosenFilterValue = clickedFilter.dataset.categoryLink;
    filterSelect.value = chosenFilterValue;
    filterSelect.dispatchEvent(new Event('change'));
  });
}
function addListenerToCatFilter() {
  var filterSelect = document.getElementById('wl_category_filter');
  if (!filterSelect) return;
  filterSelect.addEventListener('change', function (e) {
    window.location.href = e.target.value;
  });
}
function addOpenInvoiceModalListeners() {
  // TODO ajaxanrop med ID
  var allLargeProducts = _toConsumableArray(document.querySelectorAll('.products .product'));
  var _iterator2 = _createForOfIteratorHelper(allLargeProducts),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var largeProduct = _step2.value;
      var getInvoiceBtn = largeProduct.querySelector('.wl-request-invoice-btn');
      var productId = Number(largeProduct.dataset.productId);
      if (!getInvoiceBtn) continue;
      if (!productId || isNaN(parseInt(productId))) {
        console.warn('Produkt i produktlista markerad som stor produkt saknade ID, fakturaförfrågning kommer inte kunna genomgföras');
        continue;
      }
      getInvoiceBtn.addEventListener('click', getInvoiceModalHtml.bind(largeProduct, productId));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}